import script from "./BookingField.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingField.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__